export default __webpack_public_path__ + "static/media/evse_error.1a00c4a3.svg";